import { Col, Descriptions, Form, FormInstance, message, Modal, Row, Select } from "antd";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import Server from "../../../server/Server";
import URL from "../../../server/URL";
import moment from "moment";
import { LineOutlined } from '@ant-design/icons';

interface IBindSalesComparisonMember {
    memberID: string,
    salesID: string | null,
    salesName: string | null
    reLoad: () => void
}

const BindSalesComparisonMember = forwardRef((props: IBindSalesComparisonMember, ref: any) => {
    const { memberID, salesID, salesName, reLoad } = props;
    const [visible, setVisible] = useState(false);
    const [salesData, setSalesData] = useState<any>([]);
    const [member, setMember] = useState<any>(null);
    const formRef = useRef<FormInstance>(null);

    useImperativeHandle(ref, () => ({
        setVisible: setVisible,
    }));

    useEffect(() => {
        if (visible) {
            formRef.current?.resetFields();
            loadSales();
            loadMember();
        }
    }, [visible]);

    const loadMember = () => {
        var request = {
            memberID: memberID
        };
        Server.Post(URL.ComparisonMember.GetComparisonMember, request, false).then((response: any) => {
            if (response.isSuccess) {
                setMember(response);
            }
        })
    }

    const loadSales = () => {
        Server.Post(URL.Sales.GetSalesOptions, {}, false).then((response: any) => {
            if (response.isSuccess) {
                setSalesData(response.data);
            }
        })
    }

    const onSave = () => {
        formRef.current?.validateFields().then((values => {
            var params = {
                memberID: memberID,
                salesID: values.sales?.value ?? null,
                salesName: values.sales?.label ?? null
            };
            Server.Post(URL.ComparisonMember.BindSalesComparisonMember, params).then((response: any) => {
                if (response.isSuccess) {
                    message.success('绑定成功');
                    setVisible(false);
                    reLoad();
                } else {
                    message.warn(response.returnMsg);
                }
            })
        }));
    }

    const onCancel = () => {
        setVisible(false);
    }
    const filterOption = (input: string, option?: { label: string; value: string }) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    return <Modal width={600} title={'绑定业务'} visible={visible}
        onCancel={onCancel}
        onOk={onSave}
        maskClosable={false}
        bodyStyle={{ padding: '10px' }}
    >
        <Form ref={formRef}
            labelCol={{ flex: '85px' }}
            labelWrap
            scrollToFirstError={true}>
            <div className="group"><LineOutlined rotate={90} style={{ color: '#1890ff' }} />
                {'会员信息'}
            </div>
            <Row>
                <Col span={12}>
                    <Form.Item style={{ marginBottom: '5px' }} label={'会员账号'} name={'account'} initialValue={''} >
                        {member?.account}
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item style={{ marginBottom: '5px' }} label={'会员名称'} name={'name'} initialValue={''} >
                        {member?.name}
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item style={{ marginBottom: '5px' }} label={'手机号码'} name={'tel'} initialValue={''} >
                        {member?.tel}
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item style={{ marginBottom: '5px' }} label={'会员类型'} name={'memberType'} initialValue={''}>
                        {member?.memberType}
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item style={{ marginBottom: '5px' }} label={'上级代理'} name={'superiorMember'} initialValue={''}>
                        {member?.superiorMember}
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item style={{ marginBottom: '5px' }} label={'公司名称'} name={'companyName'} initialValue={''}>
                        {member?.companyName}
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item style={{ marginBottom: '5px' }} label={'所属组织'} name={'organizationName'} initialValue={''}>
                        {member?.organizationName}
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item style={{ marginBottom: '5px' }} label={'注册时间'} name={'createTime'} initialValue={''}>
                        {moment(member?.createTime).format('YYYY-MM-DD HH:mm:ss')}
                    </Form.Item>
                </Col>
                <div className="group"><LineOutlined rotate={90} style={{ color: '#1890ff' }} />
                    {'业务绑定'}
                </div>
                <Col span={24}>
                    <Form.Item style={{ marginBottom: '5px' }} label={'业务员'}
                        name={'sales'} initialValue={salesID ? { value: salesID, label: salesName } : null}
                        rules={[{ required: true, message: '请选择业务员' }]}>
                        <Select labelInValue
                            allowClear
                            placeholder={'选择业务员'}
                            style={{ width: '100%' }}
                            options={salesData}
                            showSearch
                            optionFilterProp="children"
                            filterOption={filterOption} />
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    </Modal>
});
export default BindSalesComparisonMember;